'use client';

import { useEffect } from 'react';
import { errorLogger } from '@/lib/errorLogger';
import BugReportButton from './BugReportButton';

/**
 * Initialize error logger and render bug report button
 * Add this to the root layout
 */
export default function ErrorLoggerInit() {
  useEffect(() => {
    errorLogger.init();
    // Initialize web vitals reporting
    import('@/lib/webVitals').then(({ reportWebVitals }) => reportWebVitals()).catch(() => {});
  }, []);

  return <BugReportButton />;
}

